import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { ChangesPage } from './ChangesPage'

export const routes: RouteObject[] = [{ path: '/changes', element: <ChangesPage /> }]

export const nav: NavItem[] = [{ path: '/changes', label: 'Журнал', icon: 'journal', mobile: 'more', order: 90 }]
